<div class="flex-col inactivity-modal">
  <div>
    <span class="icon ui-icon-time"></span>
  </div>
  <div class="title">Are you still here ?</div>
  <div class="description">You will be signed out in {{ secondsLeft }}</div>
  <button mat-flat-button color="primary" (click)="close()">Yes</button>
</div>
